import { post, get } from "../xhr";


export async function createCase (data) {
    const formData = new FormData();
    formData.append('batna', data.banta);
    formData.append('monetaryClaim', data.monetaryClaim);
    for await (let evidence of data.evidences){
        formData.append('evidences', evidence);
    }

    for await (let [key, fact] of Object.entries(data.facts)) {
        formData.append(key, fact);
    }


    for await (let [key, claimant] of Object.entries(data.claimants)) {
        formData.append(`claimants[${key}]`, JSON.stringify({
            ...claimant
        }));
    }

    for await (let [key, defendant] of Object.entries(data.defendants)) {
        formData.append(`defendants[${key}]`, JSON.stringify({...defendant}));
    }
    return post('/resolution/create-case', 'multipart/form-data', formData);
}

export function getCases(page = 1) {
    return get(`/resolution/get-cases/?page=${page}`, 'application/json')
}

export async function acceptCaseInvite(data, id) {
    const formData = new FormData();

    for await (let [key, personnel] of Object.entries(data.personnels)) {
        formData.append(`personnels[${key}]`, JSON.stringify({
            ...personnel
        }));
    }

    for await (let evidence of data.evidences) {
        formData.append('evidences', evidence);
    }

    formData.append('description', data.description);
    formData.append('admitToClaims', data.admitToClaims);
    formData.append('sumToPay', data.sumToPay);
    formData.append('monetaryClaim', data.monetaryClaim);
    formData.append('counterClaim', data.counterClaim);

    return post(`/resolution/accept-case-invite/${id}`, 'multipart/form-data', formData)
}

export function getCaseDetail(id) {
    return get(`/resolution/get-case/${id}`, 'application/json');
}

export function queryCases(query){
    return get(`/resolution/query-cases/?gt=${query.gt}&lt=${query.lt}`, 'application/json');
}


export function updateCaseStatus (data) {
    return post('/resolution/update-Status', 'application/json', data)
}

export function assignCaseMediator(data, caseId){
    return post(`/resolution/assign-mediator/${caseId}`, 'application/json', data);
}

export function resendInvite(caseId) {
    return post(`/resolution/resend-invite/${caseId}`, 'application/json', {});
}

// export function 